import { KrLandslideFormTypes } from "../../contexts/krFormContext";
import { Option } from "../../components/shared/selectInput/types/selectInputProps";

export type tableRecord = {
    id?: string,
    zdarzenie?: string,
    czas?: string,
    czasUwagi?:string,
    uwagi?: string,
    przyczyny?: string,
    localUUID?: string
}

export const genesisAndAgeTableList = (krForm: KrLandslideFormTypes, MovementCauseDict: Option[] | undefined, EventeTypeDict: Option[] | undefined, PoraRokuDict: Option[] | undefined) => {
    var records: tableRecord[] = [];
    var developmentsCopy = structuredClone(krForm.developments);
    developmentsCopy?.sort((a, b) => a.kolejnosc! - b.kolejnosc!);
    if (developmentsCopy && developmentsCopy.length > 0) {
        for (var i = 0; i < developmentsCopy.length; i++) {
            var record: tableRecord = {};
            var development = developmentsCopy[i]
            record.id = development.globalid;
            record.localUUID = development.localUUID;
            record.uwagi = development.genezA_OPIS;
            record.czasUwagi = development.datA_UWAGI;
            record.przyczyny = "";
            if (krForm.movementCause) {
                // eslint-disable-next-line no-loop-func
                var elements = krForm.movementCause.filter((movementCaus) => 
                    development.globalid ? 
                    movementCaus.osuwiskO_ROZWOJ_GID ? development.globalid === movementCaus.osuwiskO_ROZWOJ_GID : development.globalid === movementCaus.devId : 
                    development.localUUID === movementCaus.devId
                )
                for (var j = 0; j < elements.length; j++) {
                    // eslint-disable-next-line no-loop-func
                    var przyczyna = MovementCauseDict?.find((option: Option) => {
                        if (krForm.movementCause) return option.value === elements[j].przyczynA_RUCHU_SID;
                        return false;
                    })?.name;
                    record.przyczyny += przyczyna + `${elements.length !== j + 1 ? ", " : ""}`;
                }
            }
            // eslint-disable-next-line no-loop-func
            record.zdarzenie = EventeTypeDict?.find((option: Option) => {
                if (developmentsCopy) return option.value === development.tyP_ZDARZENIA_SID;
                return false;
            })?.name;

            var przedPo = '';
            if (development.przeD_PO_SID === 1) przedPo = "przed";
            else if (development.przeD_PO_SID === 2) przedPo = "po";

            if (development.rodzaJ_OKRESU_CZASU_SID === 1) {
                record.czas = `${przedPo ? przedPo + ' ' : ''}${development.datA_ROK}-${zeroPaddingForDate(development.datA_MIESIAC!)}-${zeroPaddingForDate(development.datA_DZIEN!)}`
                if (development.czY_ZAKRES_DAT === 1) {
                    var data = ` – ${development.datA_ROK_DO}-${zeroPaddingForDate(development.datA_MIESIAC_DO!)}-${zeroPaddingForDate(development.datA_DZIEN_DO!)}`
                    record.czas += data
                }
            }
            if (development.rodzaJ_OKRESU_CZASU_SID === 2) {
                record.czas = `${przedPo ? przedPo + ' ' : ''}${development.datA_ROK}-${zeroPaddingForDate(development.datA_MIESIAC!)}`
                if (development.czY_ZAKRES_DAT === 1) {
                    var data2 = ` – ${development.datA_ROK_DO}-${zeroPaddingForDate(development.datA_MIESIAC_DO!)}`
                    record.czas += data2
                }
            }
            if (development.rodzaJ_OKRESU_CZASU_SID === 3) {
                record.czas = `${przedPo ? przedPo + ' ' : ''}${development.datA_ROK}` +
                    `${development.czY_ZAKRES_DAT === 1 ? " – " + development.datA_ROK_DO : ""}`
            }
            if (development.rodzaJ_OKRESU_CZASU_SID === 4) {
                // eslint-disable-next-line no-loop-func
                var dictPora = PoraRokuDict?.find((option: Option) => {
                    if (developmentsCopy) return option.value === development.porA_ROKU_SID;
                    return false;
                });
                // eslint-disable-next-line no-loop-func
                var DictPoraDo = PoraRokuDict?.find((option: Option) => {
                    if (developmentsCopy) return option.value === development.porA_ROKU_DO_SID;
                    return false;
                });
                record.czas = `${przedPo ? przedPo + ': ' : ''}${dictPora?.name} ${development.datA_ROK}` +
                    `${development.czY_ZAKRES_DAT === 1 ? ` - ${DictPoraDo?.name} ${development.datA_ROK_DO}` : ""}`
            }
            if (development.rodzaJ_OKRESU_CZASU_SID === 5) {
                record.czas = `${przedPo ? przedPo + ' ' : ''}${development.wiek}`
            }
            if (development.rodzaJ_OKRESU_CZASU_SID === 6) {
                record.czas = `${przedPo ? przedPo + ': ' : ''}${development.epoka}`
            }
            records.push(record);
        }
    }
    return records;
}

const zeroPaddingForDate = (value: number) => {
    return value < 10 ? `0${value}` : value;
}